import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import query from './query';
import mapFilters from './map-filters';

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,

  modules: {
    query,
    mapFilters,
  },
};
